import { render, staticRenderFns } from "./grouped-sales.vue?vue&type=template&id=ae1a3658&scoped=true"
import script from "./grouped-sales.vue?vue&type=script&lang=js"
export * from "./grouped-sales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1a3658",
  null
  
)

export default component.exports